import React from 'react';
import { Link } from 'react-router-dom'; // Import Link from React Router
import homeImage from '../Images/Homeimg.jpg';
import "./Home.css";
import Typewriter from 'typewriter-effect';
import About from './About'

const Home = () => {
  return (
    <>
      <div className='home'>
        <div>
          <img src={homeImage} alt="Homeimg" className="centered-image" />
        </div>
        <h1>
          Hello, I am<br />
          <Link to="/About" className='namelink'>Sharanya</Link><br />
          I am from Bangalore and I'm a<br />
          <Typewriter
            options={{
              strings: [
                'Fresher',
                'Tech Enthusiast',
                'Software Developer',
                'Full stack Developer',
              ],
              autoStart: true,
              loop: true,
            }}
          />
        </h1>
      </div>

      <div className='HorLine'>
        <hr></hr>
      </div>
      <About />
    </>
  );
};

export default Home;
